export default [
  {
    path: "/duracionesContrato",
    component: () => import("@/views/duracionesContrato/Listar.vue"),
  },
  {
    path: "/duracionesContrato/crear",
    component: () => import("@/views/duracionesContrato/Crear.vue"),
  },
  {
    path: "/duracionesContrato/editar/:id",
    component: () => import("@/views/duracionesContrato/Editar.vue"),
  },
  {
    path: "/duracionesContrato/descuentos/:id",
    component: () => import("@/views/duracionesContrato/EditarModificadores.vue"),
  },
];
